module.exports = __webpack_public_path__ + "img/clock.f2c3eee5.svg";